import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <a 
              href="https://www.mnvsolutions.co.in/" 
              target="_blank" 
              rel="noopener noreferrer" 
              className="flex items-center gap-2 mb-4"
            >
              <img 
                src="/assets/mnv-logo.png" 
                alt="MNV Solutions" 
                className="h-8 w-auto object-contain"
              />
              <span className="text-white font-bold">MNV Solutions</span>
            </a>
            <p className="text-sm text-gray-400">
              Your trusted partner for WhatsApp Business API solutions. Empowering businesses to connect with customers seamlessly.
            </p>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">All Services</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">WhatsApp API</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">Chatbot Integration</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">Broadcasting</Link></li>
              <li><Link to="/services" className="hover:text-blue-400 transition-colors">Analytics</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/privacy-policy" className="hover:text-blue-400 transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms-of-service" className="hover:text-blue-400 transition-colors">Terms of Service</Link></li>
              <li><Link to="/refund-policy" className="hover:text-blue-400 transition-colors">Refund Policy</Link></li>
              <li><Link to="/gdpr-compliance" className="hover:text-blue-400 transition-colors">GDPR Compliance</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-1 flex-shrink-0" />
                <div>
                  <div>+91 9866461437</div>
                  <div>+91 8985326237</div>
                </div>
              </li>
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>info@mnvsolutions.co.in</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>18-2-163, Ashok Nagar, Tirupati-517501</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400">
          <a href="/admin" className="inline-block mb-3 hover:text-blue-400">Enquiries Admin</a>
          <p>&copy; {new Date().getFullYear()} MNV Solutions. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;